var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-share",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.facebookLink(_vm.url)}}},[_c('img',{attrs:{"src":"/img/facebook-letter-logo.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }